module.exports = __webpack_public_path__ + "img/logo2024_7_26 10_55_51.5c7b5be3.png";